import { type ReactNode, useEffect, useMemo } from 'react';
import { useStepperDialog } from '@ics-portal/guardian';
import { hasDirtyFields } from '@utils/hasDirtyFields';
import {
    type ProjectFormAttributes,
    useProjectFormContext,
} from '../../ProjectForm';
import { ProjectFormCustomer } from './ProjectFormCustomer';

interface ProjectFormCustomerStepProps {
    isEditMode?: boolean;
}

export function ProjectFormCustomerStep({
    isEditMode,
}: ProjectFormCustomerStepProps): ReactNode {
    const { registerProceed, setPrimaryDisabled } = useStepperDialog();
    const { form, onSubmit } = useProjectFormContext();
    const {
        formState: { errors, dirtyFields },
    } = form;

    const customerFields = useMemo<(keyof ProjectFormAttributes)[]>(
        () => [
            'customerName',
            'customerEmail',
            'plantName',
            'locationStreet',
            'locationCity',
            'locationCountry',
        ],
        [],
    );
    const primaryDisabled =
        customerFields.some((field) => Boolean(errors[field])) ||
        (Boolean(isEditMode) && !hasDirtyFields(dirtyFields));
    const hasValidationErrors = customerFields.some((field) =>
        Boolean(errors[field]),
    );

    useEffect(() => {
        registerProceed(async () => {
            return await onSubmit();
        });
    }, [registerProceed, onSubmit]);

    useEffect(() => {
        setPrimaryDisabled(primaryDisabled, { isInvalid: hasValidationErrors });
    }, [setPrimaryDisabled, primaryDisabled, hasValidationErrors]);

    return <ProjectFormCustomer />;
}
